import { createSlice } from "@reduxjs/toolkit";
import urlStorage from "src/support/urlStorage";
import {
    isAdminUserLastLoginDateSearchEnabled,
    isLastLoginDateSearchType,
    sanitizeAdminUserFilterList
} from "src/support/AdminLastLoginDateSearch";

const getInitialFilterList = () => {
    const urlList = urlStorage.getItem('ud');
    const sanitizedUrlList = sanitizeAdminUserFilterList(urlList);
    const hasStoredLastLoginDateFilter = Array.isArray(urlList) && urlList.some((filterItem) => isLastLoginDateSearchType(filterItem?.searchType));

    if (!isAdminUserLastLoginDateSearchEnabled() && hasStoredLastLoginDateFilter) {
        if (sanitizedUrlList.length > 0) {
            urlStorage.setItem('ud', sanitizedUrlList);
        } else {
            urlStorage.removeItem('ud');
        }
    }

    return sanitizedUrlList;
};

const initialState = {
    filterList: getInitialFilterList()
};

const slice = createSlice({
    name: "adminFilter",
    initialState: initialState,
    reducers: {
        setFilterList: {
            reducer: (state, action) => {
                state.filterList = sanitizeAdminUserFilterList(action.payload);
                urlStorage.setItem('ud', state.filterList);
            },
        },
        clearFilterByKey: {
            reducer: (state, action) => {
                state.filterList.splice(action.payload, 1);
                if (Object.entries(state.filterList).length > 0) {
                    urlStorage.setItem('ud', state.filterList);
                } else {
                    urlStorage.removeItem('ud');
                }
                return state;
            },
        },
        clearAllFilter: {
            reducer: (state, action) => {
                state.filterList = [];
                urlStorage.removeItem('ud');
                return state;
            },
        },
        clearArryVal: {
            reducer: (state, action) => {
                let data = action.payload.data;
                let _ary = state.filterList.find(f => f.searchKey === data.key).searchKeywordArr;
                if (_ary.length === 1) {
                    let idx = state.filterList.findIndex(f => f.searchKey === data.key)
                    state.filterList.splice(idx);
                }
                else {
                    state.filterList.forEach((ele, i) => {
                        if (ele.searchKey === data.key) {
                            ele.searchKeywordArr = ele.searchKeywordArr.filter(f => f !== data.val);
                        }
                    })
                }
                urlStorage.setItem('ud', state.filterList);
                return state;
            },
        },
    },
});

export let { setFilterList, clearFilterByKey, clearAllFilter, clearArryVal } = slice.actions;

export default slice.reducer;
